module.exports = __webpack_public_path__ + "img/p2nav2-h_906b385.906b3853.png";